import { Navigate, useLocation } from 'react-router-dom';
import { useTenantProfile } from '../contexts/TenantProfileContext';
export default function TenantDashboardPage() {
  const { tenant, kind, loading } = useTenantProfile();
  const location = useLocation();
  const isImpersonation = location.pathname.startsWith('/impersonate');
  const myInformationPath = isImpersonation ? '/impersonate/my-information' : '/my-information';

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-red-700" />
      </div>
    );
  }

  if (kind === 'applicant') {
    return <Navigate to={myInformationPath} replace />;
  }

  if (kind === 'prospect') {
    return <Navigate to={myInformationPath} replace />;
  }

  if (tenant?.moveIn) {
    return <Navigate to={isImpersonation ? '/impersonate/move-in' : '/move-in'} replace />;
  }

  if (tenant?.moveOut) {
    return <Navigate to={isImpersonation ? '/impersonate/move-out' : '/move-out'} replace />;
  }

  return <Navigate to={myInformationPath} replace />;
}
